import ShippingListTable from "./ShippingListTable"
import ShippingPageLayout from "./ShippingPageLayout"

const ShippingListPage = () => {
  return (
    <ShippingPageLayout>
      <ShippingListTable />
    </ShippingPageLayout>
  )
}

export default ShippingListPage